// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_fz-3";
export var flatBottomCorners = "_fz-5";
export var productImage = "_fz-0";
export var quantityContainer = "_fz-2";
export var quantityHeader = "_fz-6";
export var tooltip = "_fz-1";
export var wrapAndEllipsesOverflow = "_fz-4";